<template>
    <div id="workLoadList">
      <div class="scrollTop" @click="toTop" v-show="toTopIsShow"><img src="../../assets/imgs/home/totop.png" alt=""></div>
      <div class="workload-body withgray">
       <div class="box">
         <el-row class="box-filter">
           <el-col :span="8" style="text-align: center;">
             <el-select placeholder="请选择岗位" size="mini" v-model="queryParams.roleId" @change="onSelectedRole" style="width:80% !important">
                <el-option :key="1" label="总部" :value="1"></el-option>
                <el-option :key="2" label="业务" :value="2"></el-option>
              </el-select>
          </el-col>
           <el-col :span="7" style="text-align: center;">
             <el-select placeholder="纬度一" size="mini" v-model="queryParams.dateType" @change="onSelectedBigDate" style="width:80% !important">
                <el-option :key="1" label="年报" :value="1"></el-option>
                <el-option :key="2" label="季报" :value="2"></el-option>
                <el-option :key="3" label="月报" :value="3"></el-option>
                <el-option :key="4" label="日报" :value="4"></el-option>
              </el-select>
           </el-col>
           <el-col :span="9" style="text-align: center;">
             <el-date-picker v-model="queryParams.sYear" size="mini" style="width:90% !important" type="year" :editable="false" :clearable="false" placeholder="选择年" v-if="queryParams.dateType==1" @change="onSelectedYear" ></el-date-picker>
             <el-date-picker v-model="queryParams.sMonth" size="mini" style="width:90% !important" type="month" :editable="false" :clearable="false" placeholder="选择月" v-if="queryParams.dateType==3" @change="onSelectedMonth"></el-date-picker>
             <el-date-picker v-model="queryParams.sDate" size="mini" style="width:90% !important" type="date" :editable="false" :clearable="false" format="yy-MM-dd" v-if="queryParams.dateType==4" @change="onSelectedDate" value-format="yyyy-MM-dd" placeholder="开始时间" class="fixwidth"></el-date-picker>
             <el-select placeholder="季度" size="mini" v-model="queryParams.sQuarter" v-if="queryParams.dateType==2" @change="onSelectedSquarter" :editable="false" :clearable="false" style="width:80% !important">
                <el-option :key="1" label="2019-1季度" :value="201901"></el-option>
                <el-option :key="2" label="2019-2季度" :value="201904"></el-option>
                <el-option :key="3" label="2019-3季度" :value="201907"></el-option>
                <el-option :key="4" label="2019-4季度" :value="201910"></el-option>
              </el-select>
           </el-col>
         </el-row>
      </div>  
       <div class="box withwhite">
          <div class="box-tab">
            <div class="box-tab-item" @click="changeTab('User')" v-bind:class="{ 'box-tab-item-active': this.teamTab=='User'}">人员</div><div class="box-tab-item" @click="changeTab('Date')" v-bind:class="{ 'box-tab-item-active': this.teamTab=='Date'}">时间</div>
          </div>
       </div>
       <div class="box withgray box-target" v-loading="loadings.chartLoading">
          <el-row>
              <el-col :span="8">总店次:<h1 class="box-target-value">{{this.targetDatas.visitNum}}</h1></el-col>
              <el-col :span="8">总人数:<h1 class="box-target-value">{{this.targetDatas.userNum}}</h1></el-col>
              <el-col :span="8">人均店次:<h1 class="box-target-value">{{this.targetDatas.avgNum}}</h1></el-col>
          </el-row>
       </div>
       <div class="box withgray" style="height:430px">
         <div v-if="showBack" @click="goBack" class="chart-goback">返回</div>
          <div class="chartnew" v-loading="loadings.chartLoading">
              <!-- 为 ECharts 准备一个具备大小（宽高）的 DOM -->
              <div id="main" style="width: 98%;height:400px;"></div>
          </div>
       </div>
       <div class="box" style="margin-bottom: 10px;">
         <el-table :data="rankDatas" size="mini" stripe border v-loading="loadings.tableLoading" element-loading-text="加载中">
            <el-table-column show-overflow-tooltip prop="RankId" label="排名" align="center" min-width="25%">
              <template slot-scope="scope">
                <img v-if="scope.row.RankId<4" report-img :src="imgHost+'/Resource/Images/'+scope.row.RankId+'.png'" width="30">{{scope.row.RankId<4?'':(scope.row.RankId==11?'--':scope.row.RankId)}}
                
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="UserName" label="用户" min-width="25%"></el-table-column>
            <el-table-column show-overflow-tooltip prop="VisitNum" label="店次" min-width="25%"></el-table-column>
            <el-table-column show-overflow-tooltip prop="NumberCount" label="点数" min-width="25%"></el-table-column>
          </el-table>
       </div>
      </div>
    </div>
  </template>
  <script>
  import { message,imgServerHost, getBaseUrl,getKPIRegionCascaderOption,getKPIRoleOption,GetWorkLoadReport,getWorkRoleByUser} from "../../api/api";
  import libs from "../../utils/libs";
  import moment from "moment";
  import store from "../../utils/storage";
  import echarts from 'echarts';
  
  const animationDuration = 6000

  export default {
    data() {
      return {
        uid:0,
        teamTab:'User',
        title:'',
        showFilter:false,
        searchLoading:false,
        showBack:false,
        imgHost:getBaseUrl(),
        loadings: {
          loading: false,
          chartLoading: false,
          tableLoading: false,
          importLoading: false
        },
        curUser:{},
        targetDatas:{
          visitNum:0,
          userNum:0,
          avgNum:0
        },
        toTopIsShow:false,//控制回到顶部按钮是否显示
        rankDatas:[],
        roles: [],
        regionCascaders:[],
        regionIds:[],
        curParentRegion:{},
        curRegion:{},
        queryParams:{
          sDate:moment().format("YYYY-MM-DD"),
          eDate:moment().format("YYYY-MM-DD"),
          roleId: 1,
          regionId:0,
          userId:1,
          dateType:3,
          sYear:'2019',
          sQuarter:201901,
          sMonth:moment().format("YYYY-MM"),
          reportType:1,
          sWhere:''
        },
        tableDatas:[],
        chartTitle:'',
        legendData:[],
        xAxisData:[],
        seriesData:[],
        dimensionsData:[],


      };
    },
    mounted() {
      this.uid=this.$route.params.uid;
      this.queryParams.userId=this.$route.params.uid;
      //this.getRoles();
      //this.GetWorkRoleByUser();
      //console.log(this.teamTab);
      //this.getRegionCascader();
      //console.log(this.regionCascaders);
       //this.type=this.$route.params.type;
       this.chartTitle="";
       this.search();
       //console.log(this.regionCascaders);
       
       
    },
    created(){
            var _this=this;
            window.onscroll=function () {
                //鼠标滚轮滚动距离超过10像素时，回到顶部按钮才显示
                let top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
                if(top>30){
                    _this.toTopIsShow=true;
                }else{
                    _this.toTopIsShow=false;
                }
            }
        },
    methods: {
      toBack(){
        //history.back();
        this.showBack=false;
        this.search();
      },
      getRandIcon(){
        //return '../../assets/imgs/home/'+value+'.png';
        return '../../assets/imgs/home/1.png';
      },
      // getRoles() {
      //   getKPIRoleOption(1).then(res => {
      //     if (res.data.Code != 1) return;
      //     this.roles = res.data.Data;
      //   });
      // },
      // GetWorkRoleByUser(){
      //   getWorkRoleByUser(this.queryParams.userId).then(res => {
      //     if (res.data.Code != 1) return;
      //     this.curUser = res.data.Data;
      //     this.queryParams.roleId=this.curUser.Id;
      //     //console.log(this.curUser);
      //   });
      // },
      changeTab(value){
        
        this.teamTab=value;
        this.search();
        //this.queryParams.reportType=(value=='User'?1:2);
      },
      changeHandler(value){
        this.search();
        if(value=='Date'){
          this.showBack=false;
          this.chartTitle="";
        }
        if(value=='User'&&this.curRegion.RegionId) this.showBack=true;
      },
      onSelectedBigDate(selVal){
        var today=moment().format("YYYY-MM-DD");
        this.queryParams.sDate=today;
        var sq='01';
      if (moment().format("M")>=4 && moment().format("M")<=6) sq='04';
      if (moment().format("M")>=7 && moment().format("M")<=9) sq='07';
      if(moment().format("M")>=10) sq='10';
      this.queryParams.sQuarter=parseInt( moment().format("YYYY")+sq);
      this.queryParams.sMonth=moment().format("YYYY-MM");
      this.search();
        //if(selVal==2) 
      },
      onSelectedYear(){
        this.showBack=false;
        this.curParentRegion={};
        this.curRegion={};
        this.search();
      },
      onSelectedSquarter(){
        this.showBack=false;
        this.curParentRegion={};
        this.curRegion={};
        this.search();
      },
      onSelectedMonth(){
        this.showBack=false;
        this.curParentRegion={};
        this.curRegion={};
        this.search();
      },
      onSelectedDate(){
        this.showBack=false;
        this.curParentRegion={};
        this.curRegion={};
        this.search();
      },
      onSelectedRole(){
        this.showBack=false;
        this.curParentRegion={};
        this.curRegion={};
        this.search();
      },
       goBack(){
        this.regionIds=[];
        this.curParentRegion=this.curRegion.RegionName?this.curParentRegion:{};
        this.curRegion={};
        this.chartTitle="";
        this.search();
        
        if(this.curParentRegion.RegionName==null) this.showBack=false;
      },
      toTop(){
        let top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
        if(document.documentElement.scrollTop>0) document.documentElement.scrollTop=0;
        if(document.body.scrollTop>0) document.body.scrollTop=0;
        if(window.pageYOffset>0) window.pageYOffset=0;
      },
      search(){
        this.loadings.chartLoading=true;
        this.queryParams.reportType=this.teamTab=='User'? 1:2;
        
        var y=new Date(this.queryParams.sYear);
        var m=new Date(this.queryParams.sMonth);

        if(this.queryParams.dateType==1) this.queryParams.sDate=y.getFullYear()+'-01-01';
        if(this.queryParams.dateType==2) this.queryParams.sDate=this.queryParams.sQuarter.toString().substring(0,4)+'-'+this.queryParams.sQuarter.toString().substring(4,6)+'-01';
        if(this.queryParams.dateType==3) this.queryParams.sDate=m.getFullYear().toString()+'-'+((m.getMonth()+1)<10?('0'+(m.getMonth()+1).toString()):(m.getMonth()+1).toString()) +'-01';
        this.queryParams.sWhere = this.curRegion.RegionName? (this.curParentRegion.RegionName+'-'+this.curRegion.RegionName): this.curParentRegion.RegionName;

        console.log(this.queryParams);

        GetWorkLoadReport(this.queryParams).then(res=>{
          if(res.data.Code!=1) return;
          console.log(res.data.Data.datatable);
          this.targetDatas.visitNum=res.data.Data[0].datatable[0].VisitNum;
          this.targetDatas.userNum=res.data.Data[0].datatable[0].UserNum;
          this.targetDatas.avgNum=res.data.Data[0].datatable[0].AvgNum;
          this.tableDatas=res.data.Data[1].datatable;
          this.rankDatas=res.data.Data[2].datatable;
          this.splitData();
          this.initChart();
          this.loadings.chartLoading=false;
          //this.queryParams.sDate=moment().format("YYYY-MM-DD");
        }
        );
        //console.log(this.queryParams);
        
      },
      splitData(){
        this.seriesData=this.ChartData_Series(this.tableDatas);
        //console.log(this.tableDatas);
        this.dimensionsData=this.ChartData_Dimensions(this.tableDatas);

      },
      ChartData_Series(){
        var newArr=[];
        var Obj={};
        if(this.teamTab=='Date'){
          Obj={
                type:'line',
                animationDuration:2800,
                animationEasing:'cubicInOut',
                 markLine: {
                        silent: true,
                        lineStyle: {
                          normal: {
                            color: 'red'                   // 这儿设置安全基线颜色
                          }
                        },
                        // data: [{
                        //     yAxis: 34
                        // }],
                        label: {
                          normal: {
                            //formatter: '达标线34',           // 这儿设置安全基线
                            position:'middle',
                          },
                          
                        },
                    },


                };
        };
        if(this.teamTab=='User'){
          Obj={
                type:'bar',
                stack:'vistors',
                barWidth:'90%',
                
                label:{
                    normal: {
                        show: true,
                        color:'black',//字体黑色
                        fontSize: 10,
                        position: 'inside'//显示在中间。insideRight
                    }
                  },
                animationDuration:2800,
                animationEasing:'cubicInOut'
                };
        };
        
        var firstObj={};
        firstObj=this.tableDatas[0];
        for(var x in firstObj){
          if(x!='product')
          newArr.push(Obj);
        }
        return newArr;
      },
      
      ChartData_Dimensions(){//第一列必须是product
        var newArr=['product'];
        var firstObj={};
        firstObj=this.tableDatas[0];
        for(var x in firstObj){
          if(x!='product')
          newArr.push(x);
        }
        return newArr;
      },
      initChart(){
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(document.getElementById('main'));
        let that=this;
        // 指定图表的配置项和数据
        var option = {
            title: {
                //text: 'aaa',
                text:this.chartTitle,
                textStyle:{
                    //文字颜色
                    color:'#000000',
                    //字体风格,'normal','italic','oblique'
                    fontStyle:'normal',
                    //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
                    fontWeight:'bold',
                    //字体系列
                    fontFamily:'sans-serif',
                    //字体大小
            　　　　 fontSize:10,
                    
                },
                left:'center'
            },
            //tooltip: {},
            legend: {
                //data:['expected','actual']
                //data:this.legendData,
                bottom:-2
            },
            dataset: {
                // 这里指定了维度名的顺序，从而可以利用默认的维度到坐标轴的映射。
                // 如果不指定 dimensions，也可以通过指定 series.encode 完成映射，参见后文。
                //dimensions: ['product', '2015', '2016', '2017'],
                dimensions: this.dimensionsData,
                source: this.tableDatas
            },
            xAxis: {
              //data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
              //data:this.xAxisData,
              type: 'category',
              //boundaryGap: false,X轴从0开始
              axisTick: {
                //show: false
                alignWithLabel: true//X轴下面加点
              },
              axisLabel : {//坐标轴刻度标签的相关设置。
                interval:0  //每隔都显示；1每隔1个显示
                ,rotate:"45"
            }
            },
            grid: {
              left: 0,
              right: 0,
              bottom: 80,
              top: 50,
              containLabel: true
            },
            tooltip: {
              trigger: 'axis',
              //axisPointer: {
              //  type: 'cross'
              //},//去掉点击后出现的横向虚线
            //   formatter: function (val) {
            //     return val + '%';
            // },
              padding: [5, 10]
            },
            yAxis: {
              axisTick: {
                show: false
              },
              axisLabel: {
                formatter: function (val) {
                    return val;
                }
              },
            },
            dataZoom: [
                // {   // 这个dataZoom组件，默认控制x轴。
                //     type: 'slider', // 这个 dataZoom 组件是 slider 型 dataZoom 组件
                //     start: 0,      // 左边在 10% 的位置。
                //     end: 100         // 右边在 60% 的位置。
                // },
                {   // 这个dataZoom组件，也控制x轴。
                    type: 'inside', // 这个 dataZoom 组件是 inside 型 dataZoom 组件
                    start: 0,      // 左边在 10% 的位置。
                    end: 100         // 右边在 60% 的位置。
                }
            ],
            series:this.seriesData
            
        };

        // 使用刚指定的配置项和数据显示图表。
        //console.log(option);
        myChart.clear();
        myChart.setOption(option);
      myChart.off('click');
        

        if(this.queryParams.reportType==1){//区域钻取
        var touchtime = new Date().getTime();
            myChart.on('click',function(object){
              if( new Date().getTime() - touchtime > 500 ){
                  touchtime = new Date().getTime();
                  console.log("click");
              }else{
                console.log("dblclick");
                if (that.queryParams.reportType==2) return;//时间维度不钻取
                if (that.curParentRegion.RegionName!=null&&that.queryParams.roleId==1) return;//总部维度只钻取一层
                if (that.curRegion.RegionName!=null&&that.queryParams.roleId==2) return;//总部维度只钻取一层
                  that.showBack=true;
                  var newtableDatas=[];
                    var downParams=that.queryParams;
                    //var curRegion={};
                    if(that.curParentRegion.RegionName==null){
                          that.curParentRegion.RegionName=object.name;
                    }
                    else{
                           that.curRegion.RegionName=object.name;
                    }
                    if(that.curParentRegion.RegionName||that.curRegion.RegionName){
                      //that.queryParams.regionId=curRegion.RegionId;
                      that.loadings.chartLoading=true;
                      downParams.sWhere=that.curRegion.RegionName? (that.curParentRegion.RegionName+'-'+that.curRegion.RegionName): that.curParentRegion.RegionName;
                         // console.log(that.curRegion.RegionName);
                         // console.log(that.curParentRegion.RegionName);
                         // console.log(downParams.sWhere);
                          GetWorkLoadReport(downParams).then(res=>{
                            if(res.data.Code!=1) return;
                            option.dataset.source=res.data.Data[1].datatable;;
                            that.targetDatas.visitNum=res.data.Data[0].datatable[0].VisitNum;
                            that.targetDatas.userNum=res.data.Data[0].datatable[0].UserNum;
                            that.targetDatas.avgNum=res.data.Data[0].datatable[0].AvgNum;
                            that.rankDatas=res.data.Data[2].datatable;
                            myChart.setOption(option,true);
                            that.loadings.chartLoading=false;
                          }
                          );
                    }
              }
              });
        }
            

      },
    }
  };
  </script>
  
  <style scoped>
  @import "../../assets/css/kpi/kpi.css";
  </style>

  <style>
      .customWidth {
   min-width:320px;
}

      </style>


// WEBPACK FOOTER //
// src/components/kpi/WorkLoad.vue